import React, { ReactNode, useState } from 'react';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import { useThemeContext } from '../../../context/ThemeContext';
import { ThemeMode } from '../../../shared/constants';
import AppSwitch from '../app-switch/AppSwitch';
import { useStyles } from './ThemeSwitch.styles';

export interface IThemeSwitchProps {
  lightIcon?: ReactNode;
  darkIcon?: ReactNode;
  className?: string;
}

export default function ThemeSwitch(props: IThemeSwitchProps) {
  const { lightIcon, darkIcon, className } = props;
  const { theme: themeMode, setTheme } = useThemeContext();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const [isThemeConfigUpdating, setIsThemeConfigUpdating] = useState(false);

  const isLight = themeMode === ThemeMode.light;

  const swithHandler = () => {
    if (isThemeConfigUpdating) return;
    setIsThemeConfigUpdating(true);
    setTheme(isLight ? ThemeMode.dark : ThemeMode.light);
    setTimeout(() => {
      setIsThemeConfigUpdating(false);
    }, 1000);
  };

  return (
    <AppSwitch
      className={className}
      value={isLight}
      icon={
        <Box className={clsx(classes.thumbIcon, classes.darkIcon)}>
          {darkIcon ?? <DarkIcon />}
        </Box>
      }
      checkedIcon={
        <Box className={clsx(classes.thumbIcon, classes.lightIcon)}>
          {lightIcon ?? <LightIcon />}
        </Box>
      }
      onChange={swithHandler}
    />
  );
}

const LightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round">
      <circle cx="12" cy="12" r="4"></circle>
      <path d="M12 2v2"></path>
      <path d="M12 20v2"></path>
      <path d="m4.93 4.93 1.41 1.41"></path>
      <path d="m17.66 17.66 1.41 1.41"></path>
      <path d="M2 12h2"></path>
      <path d="M20 12h2"></path>
      <path d="m6.34 17.66-1.41 1.41"></path>
      <path d="m19.07 4.93-1.41 1.41"></path>
    </svg>
  );
};

const DarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"></path>
    </svg>
  );
};
